import React from 'react'
import FundsIcon from 'assets/images/funds/moneypool-2.png'
import FundsIcon2 from 'assets/images/funds/moneyPool-1.svg'
import { MoneyPoolsStatus } from 'utilities/helper/moneyPools'
import classNames from 'classnames'
import { useNavigate } from 'react-router-dom'
import { ConvertJalaliDate } from 'utilities/helper/digitToMonth'

interface IItem {
    item: MoneyPool
}

export default function Item({ item }: IItem) {
    const navigate = useNavigate()
    return (
        <div
            className=' bg-white rounded-2xl shadow-[0px 9px 29px 0px rgba(0, 0, 0, 0.2)] py-4 px-3 my-3 cursor-pointer'
            onClick={() =>
                navigate(`/fund/${item.id}`, {
                    state: { poolShipId: item.poolship.id },
                })
            }
        >
            <div className=' flex'>
                <img
                    src={
                        item.custom_avatar
                            ? item.custom_avatar
                            : item.image_id === 2
                                ? FundsIcon
                                : FundsIcon2
                    }
                    alt='fund-icon'
                    className=' w-14 h-14 rounded-full'
                />
                <div className=' mr-3 cursor-pointer'>
                    <p className=' font-extrabold'>صندوق {item.name}</p>
                    <p className=' text-sm text-gray-4 mt-2'>
                        {item.active_members_count} عضو, پس‌انداز
                    </p>
                </div>
            </div>
            <hr className=' my-3' />
            <div>
                {item.show_box_balance && (
                    <div className=' flex justify-between my-2'>
                        <p className=' text-gray-2 text-sm'>موجودی صندوق</p>
                        <p className=''>
                            {Number(
                                Number(item.hamyan_balance) +
                                Number(item.bank_balance),
                            ).toLocaleString()}{' '}
                            تومان
                        </p>
                    </div>
                )}
                <div className=' flex justify-between my-2'>
                    <p className=' text-gray-2 text-sm'>حق عضویت</p>
                    <p className=''>
                        {Number(item.share_value_amount).toLocaleString()} تومان
                    </p>
                </div>
                <div className=' flex justify-between my-2'>
                    <p className=' text-gray-2 text-sm'>تاریخ سر‌رسید</p>
                    <p className=''>
                        {ConvertJalaliDate(item.jalali_due_date)}
                    </p>
                </div>
            </div>
            <hr className=' my-3' />
            <div>
                <p className=' text-gray-2 text-sm'>وضعیت پرداخت دوره </p>
                <div className=' flex justify-between'>
                    <p className=' text-gray-2 my-2 text-sm'>حق عضویت :</p>
                    <div
                        className={classNames(
                            item.poolship.portion_payment_status ===
                            'ps_overpaid'
                                ? ' text-success-1 bg-success-2'
                                : item.poolship.portion_payment_status ===
                                'ps_paid'
                                    ? ' text-success-1 bg-success-2'
                                    : item.poolship.portion_payment_status ===
                                    'ps_unpaid'
                                        ? ' text-error-1 bg-error-2'
                                        : ' text-error-3 bg-error-4',
                            'py-1 px-2 rounded-md flex items-center text-sm',
                        )}
                    >
                        <img
                            className=' w-4 mx-1'
                            src={
                                MoneyPoolsStatus[
                                    item.poolship.portion_payment_status
                                    ].icon
                            }
                            alt='moneypools-status'
                        />
                        <p className=' text-sm'>
                            {
                                MoneyPoolsStatus[
                                    item.poolship.portion_payment_status
                                    ].title
                            }
                        </p>
                    </div>
                </div>
                <div className=' flex justify-between'>
                    {item.poolship.active_installments_status !== 'no-loan'
                        && item.poolship.active_installments_status !=='fully-repaid' &&
                        <>
                            <p className=' text-gray-2 my-2 text-sm'>قسط وام :</p>
                            <div
                                className={classNames(
                                    item.poolship.active_installments_status ===
                                    'paid'
                                        ? ' text-success-1 bg-success-2'
                                        : item.poolship.active_installments_status ===
                                        'unpaid'
                                            ? ' text-error-1 bg-error-2'
                                            : ' text-error-3 bg-error-4',
                                    'py-1 px-2 rounded-md flex items-center text-sm',
                                )}
                            >
                                <img
                                    className=' w-4 mx-1'
                                    src={
                                        MoneyPoolsStatus[
                                            item.poolship.active_installments_status
                                            ].icon
                                    }
                                    alt='moneypools-status'
                                />
                                <p className=' text-sm'>
                                    {
                                        MoneyPoolsStatus[
                                            item.poolship.active_installments_status
                                            ].title
                                    }
                                </p>
                            </div>
                        </>
                    }
                </div>
                {/*{*/}
                {/*    (*/}
                {/*        item.poolship.portion_payment_status === 'ps_unpaid'*/}
                {/*        ||item.poolship.portion_payment_status === 'ps_delayed'*/}
                {/*        ||item.poolship.active_installments_status === 'unpaid'*/}
                {/*        || item.poolship.active_installments_status === 'delayed')*/}
                {/*    && (*/}
                {/*    <div*/}
                {/*        className=' cursor-pointer bg-green-1 text-white py-3 text-center w-full rounded-2xl mt-4'*/}
                {/*        onClick={(event) => {*/}
                {/*            event.stopPropagation()*/}
                {/*            navigate(`/easy-pay/money-pool/init/${item.id}`)*/}
                {/*        }}*/}
                {/*    >*/}
                {/*        پرداخت*/}
                {/*    </div>*/}
                {/*)}*/}
            </div>
        </div>
    )
}
